import { useTranslation } from "react-i18next";
import useAxios from "../../../hook/useAxios";
import BreadCrumb from "../../Global/BreadCrumb";
import AddBotanicalFamilyForm from "./AddBotanicalFamilyForm";

const AddBotanicalFamily = () => {
  const { t } = useTranslation();
  const { fetchData: addBotanicalFamily, response } = useAxios(
    process.env.REACT_APP_API_URL + `/api/admin/botanical_families/new/`,
    "POST",
    false,
    "",
    true,
    true
  );

  return (
    <div className="parent-container">
      <h1 className="font-semibold text-default-text text-[16px] mt-5">
        {t("Botanical families.Add botanical family")}
      </h1>
      <BreadCrumb
        breadcrumb={[
          { name: t("Navbar.Settings"), url: "" },
          {
            name: t("Botanical families.Botanical families"),
            url: "/setting/botanical-families",
          },
          { name: t("Botanical families.Add botanical family"), url: "" },
        ]}
      />
      <div className="flex flex-wrap justify-between mt-4">
        <div className=" w-full h-fit lg:w-[49%] sc:w-[611px] bg-white rounded-md p-7 relative">
          <AddBotanicalFamilyForm
            link="/setting/botanical-families"
            title={t("Tree Species.Botanical family")}
            send={addBotanicalFamily}
            sendResponse={response}
            textButton={t("Botanical families.Add botanical family")}
          />
        </div>
        <div className="w-full h-fit lg:w-[48%] sc:w-[559px] bg-white rounded-md p-8 mt-4 lg:mt-0">
          <img
            src="/img/Botanical families.svg"
            alt="Add Botanical family"
            className="mt-4 ml-2"
          />
        </div>
      </div>
    </div>
  );
};

export default AddBotanicalFamily;
